import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class InvestmentValidationService {

  constructor(private http: HttpClient) {}

  /**
   * Save investment validation data
   * @param baseUrl - Base URL for API
   * @param clobSettings - Settings object containing sso_id and object_id
   * @param dataToSave - Array of investment data to save
   * @param issueId - Issue key
   * @param globalService - Global service data
   * @param filterParams - Filter parameters from AngularJS
   * @param rowData - Row data from AngularJS grid
   */
  saveData(
    baseUrl: string,
    clobSettings: any,
    dataToSave: any[],
    issueId: number,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = baseUrl + '/saveJsonObject?action_code=4bela7';

    // Build params with AngularJS compatible structure
    let params = _.merge({}, globalService || {}, filterParams);

    // Add CLOB data
    params.clob_data = JSON.stringify(dataToSave);
    params.clob_settings = JSON.stringify(clobSettings);
    params.issue_key = issueId;
    params.ind = 'U';

    // Ensure essential parameters with fallbacks
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250;

    // Convert params to URL encoded format (application/x-www-form-urlencoded)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    // Set headers for URL encoded data
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    // Make POST request with URL encoded data
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

